export default __webpack_public_path__ + "static/media/Rush.83821292.svg";